module.exports = __webpack_public_path__ + "static/media/190819-N-LI768-1127.a61fdc84.jpg";